const DEFAULT_TARGET_SCORE = 70
const DEFAULT_MINIMUM_FRACTION = 0.25
const ABSOLUTE_MINIMUM_OFFER = 1_000

export function findRecommendedCounterOffer({
  askingPrice,
  scoreAtPrice,
  targetScore = DEFAULT_TARGET_SCORE,
}) {
  const asking = Number(askingPrice)
  if (!Number.isFinite(asking) || asking <= 0 || typeof scoreAtPrice !== 'function') return null
  if (scoreAtPrice(asking) >= targetScore) return null

  const practicalFloor = Math.max(ABSOLUTE_MINIMUM_OFFER, asking * DEFAULT_MINIMUM_FRACTION)
  if (scoreAtPrice(practicalFloor) < targetScore) return null

  let low = practicalFloor
  let high = asking

  for (let i = 0; i < 30; i += 1) {
    const midpoint = (low + high) / 2
    if (scoreAtPrice(midpoint) >= targetScore) low = midpoint
    else high = midpoint
  }

  const rounded = Math.round(low / 1_000) * 1_000
  const recommended = scoreAtPrice(rounded) >= targetScore
    ? rounded
    : Math.floor(low / 1_000) * 1_000
  return recommended > 0 && recommended < asking * 0.99 ? recommended : null
}

export function getMinimumCounterOffer(askingPrice, recommendedPrice) {
  const asking = Number(askingPrice)
  const recommended = Number(recommendedPrice)
  if (!Number.isFinite(asking) || asking <= 0) return 0
  if (Number.isFinite(recommended) && recommended > 0) return recommended
  return Math.max(ABSOLUTE_MINIMUM_OFFER, asking * DEFAULT_MINIMUM_FRACTION)
}

export function validateCounterOffer({ counterPrice, askingPrice, recommendedPrice }) {
  const entered = Number(counterPrice)
  const minimum = getMinimumCounterOffer(askingPrice, recommendedPrice)

  if (!Number.isFinite(entered) || entered <= 0) {
    return { valid: false, reason: 'missing', entered: 0, minimum }
  }

  if (entered < minimum) {
    return { valid: false, reason: 'too-low', entered, minimum }
  }

  return { valid: true, reason: null, entered, minimum }
}

export function getSavedRenegotiatedPrice(renegotiation) {
  if (!renegotiation || renegotiation.completed !== true || renegotiation.isValid !== true) return 0
  const price = Number(renegotiation.renegotiatedPrice)
  return Number.isFinite(price) && price > 0 ? price : 0
}
